import React, { useState, useEffect, useLayoutEffect } from 'react';
import Navbar from './Navbar';
import { useSelector } from 'react-redux';

const checkDarkMode = () => {
  const isDarkMode = localStorage.getItem('dark-mode') === 'true';
  if (isDarkMode) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
  return isDarkMode;
};

// Initialize dark mode
const initialDarkMode = checkDarkMode();

const TasksLayout = ({ children, handleSubmit, handleUnEnrollClick, handleReject, rating }) => {
  const [darkMode, setDarkMode] = useState(initialDarkMode);
  const role = useSelector((state) => state.auth.user.role);

  // Check if dark mode is enabled on component mount
  useEffect(() => {
    const isDarkMode = localStorage.getItem('dark-mode') === 'true';
    setDarkMode(isDarkMode);
    
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <div className="bg-gray-50 dark:bg-gray-900 min-h-screen flex flex-col transition-colors duration-300">
      <Navbar 
        handleSubmit={handleSubmit} 
        handleUnEnrollClick={handleUnEnrollClick} 
        handleReject={handleReject} 
        rating={rating}
      />
      
      <div className="flex flex-1 pt-16">
        <main className="flex-1 p-4 transition-all duration-300">
          <div className="max-w-7xl mx-auto">
            {/* Main content */}
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default TasksLayout;